<div class="d-flex justify-content-center align-items-center vh-100">
  <div class="text-center">
    <div class="spinner-border" role="status"></div>
    <p class="mt-3">Signing you in...</p>
  </div>
</div>
